// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__PysUA","title":"FrontImage_title__3_Aa0"};